import { gql } from '@apollo/client';

import CHATROOM_FRAGMENT from '../fragments/chatRoom';
import MESSAGE_FRAGMENT from '../fragments/message';
import META_FRAGMENT from '../fragments/meta';

export const GET_MESSAGES = gql`
  ${MESSAGE_FRAGMENT}
  ${META_FRAGMENT}
  query getMessages($chatRoom: String, $pagination: PageOptionsDto, $toTime: String) {
    getMessages(chatRoom: $chatRoom, pagination: $pagination, toTime: $toTime) {
      data {
        ...MessageFragment
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const GET_MESSAGES_TO_TIME = gql`
  ${MESSAGE_FRAGMENT}
  ${META_FRAGMENT}
  query getMessages($pagination: PageOptionsDto, $chatRoom: String, $toTime: String) {
    getMessagesToTime: getMessages(pagination: $pagination, chatRoom: $chatRoom, toTime: $toTime) {
      data {
        ...MessageFragment
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const readMessages = gql`
  query readMessages($target: String!) {
    readMessages(target: $target)
  }
`;

export const GET_CONVERSATIONS = gql`
  ${MESSAGE_FRAGMENT}
  ${META_FRAGMENT}
  query getConversations($pagination: PageOptionsDto) {
    getConversations(pagination: $pagination) {
      data {
        ...MessageFragment
        unreadMessagesCount
      }
      meta {
        ...MetaFragment
      }
    }
  }
`;

export const GET_CHATROOM = gql`
  ${CHATROOM_FRAGMENT}
  query getChatRoom($transaction: String) {
    getChatRoomConversations(transaction: $transaction) {
      data {
        ...ChatRoomFragment
      }
    }
  }
`;
